export class GenericParameters {
    procedure: string;
  }